import React from "react";
import { Helmet } from "react-helmet";
import "./SuccessStories.css";
import { motion, AnimatePresence } from "motion/react";

const stories = [
    { name: "Nick Vrysellas", brokerage: "Elevate Realty", story: "APTO Websites has completely boosted my brand and now im getting more leads than I ever was!", website: "https://uvhomes.ca" },
    { name: "Nezam Ayam", brokerage: "RE/MAX Hallmark First Group Realty", story: "Switching to APTO's hosting was seamless and my site loads faster than ever. Their support team is always there when I need help!", website: "https://ayamhomes.com" },
    { name: "Wael Elzarka", brokerage: "Right at Home Realty", story: "The custom website APTO built for me looks professional and has helped me stand out in my market. I love the easy updates and secure hosting.", website: "https://waelelzarkarealty.ca" },
    { name: "Masi Esmatyar", brokerage: "CENTURY 21 TITANS REALTY", story: "The website is stunning. My clients always compliment the design and how easy it is to navigate. APTO made sure every detail was perfect and their ongoing support is top-notch.", website: "https://realtormasi.com" },
    { name: "Dave Norton", brokerage: "RE/MAX Jazz", story: "APTO's social media management has taken a huge weight off my shoulders. My online presence is growing and I'm seeing more engagement every week!" },
];

// Helper to get initials for avatar
function getInitials(name) {
    return name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase();
}

const containerVariants = {
    hidden: {},
    visible: {
        transition: {
            delay: 0.2,
            staggerChildren: 0.3,
        }
    }
}

const SuccessStories = () => (
    <>
        <Helmet>
            <title>Success Stories | AptoWebsites - Real Client Results</title>
            <meta name="description" content="See how real estate professionals have grown their business with AptoWebsites. Read client testimonials and case studies." />
            <meta name="keywords" content="success stories, testimonials, real estate website results, client reviews, AptoWebsites" />
            <meta property="og:title" content="Success Stories | AptoWebsites" />
            <meta property="og:description" content="See how real estate professionals have grown their business with AptoWebsites. Read client testimonials and case studies." />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="https://aptowebsites.com/success-stories" />
            <meta property="og:image" content="https://aptowebsites.com/og-image.jpg" />
            <link rel="canonical" href="https://aptowebsites.com/success-stories" />
        </Helmet>
        <div className="success-bg">
            <section className="success-hero">
                <h1 className="success-hero-title">Success Stories</h1>
                <p className="success-hero-subtitle">
                    Real results from real estate professionals who trust <span className="brand-highlight">APTO Websites</span>
                </p>
            </section>
            <section className="success-stories-wrapper">
                {/* <h2 className="success-title titles">What Our Clients Say</h2> */}
                <div className="success-stories-container">
                    {stories.map((story, index) => {
                        const cardContent = (
                            <div className="test-card" key={index}
                            >
                                <div className="testimonial-avatar">{getInitials(story.name)}</div>
                                <div className="testimonial-content">
                                    <p className="testimonial-quote">{story.story}</p>
                                </div>
                                <div className="test-footer">
                                    <p className="testimonial-author">- {story.name}</p>
                                    <p className="testimonial-brokerage">{story.brokerage}</p>
                                </div>
                                {story.website && (
                                    <div className="testimonial-link-indicator">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                            <polyline points="15 3 21 3 21 9"></polyline>
                                            <line x1="10" y1="14" x2="21" y2="3"></line>
                                        </svg>
                                    </div>
                                )}
                            </div>
                        );

                        return story.website ? (
                            <a key={index} href={story.website} target="_blank" rel="noopener noreferrer" className="testimonial-card-link">
                                {cardContent}
                            </a>
                        ) : (
                            <div key={index} className="testimonial-card-wrapper">
                                {cardContent}
                            </div>
                        );
                    })}
                </div>
            </section>
        </div>

        {/* <section className="wrapper">
                <div className="stories-container">
                    {stories.map((story, index) => {
                        const cardContent = (
                            <motion.div className="test-card" key={index}>
                                <div className="testimonial-avatar">{getInitials(story.name)}</div>
                                <div className="testimonial-content">
                                    <p className="testimonial-quote">{story.story}</p>
                                </div>
                                <div className="test-footer">
                                    <p className="testimonial-author">- {story.name}</p>
                                    <p className="testimonial-brokerage">{story.brokerage}</p>
                                </div>
                                {story.website && (
                                    <div className="testimonial-link-indicator">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                            <polyline points="15 3 21 3 21 9"></polyline>
                                            <line x1="10" y1="14" x2="21" y2="3"></line>
                                        </svg>
                                    </div>
                                )}
                            </motion.div>
                        );

                        return story.website ? (
                            <a key={index} href={story.website} target="_blank" rel="noopener noreferrer" className="testimonial-card-link">
                                {cardContent}
                            </a>
                        ) : (
                            <div key={index} className="testimonial-card-wrapper">
                                {cardContent}
                            </div>
                        );
                    })}
                </div>

            </section> */}

    </>
);

export default SuccessStories;
